module.exports = __webpack_public_path__ + "img/curtain_up_80.1dde022a.svg";